module.exports = __webpack_public_path__ + "static/img/icon3.5ae9a52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon3.png
// module id = fWV0
// module chunks = 1